<template>
  <div class="app-layout">
    <div class="page">
      <div class="body-content sidebar-collapsed">
        <div class="body-wrap px-2"></div>
      </div>
    </div>
  </div>
</template>
 